<template>
  <el-dialog
    :visible.sync="show"
    width="1000px"
    class="payBillModal"
    :before-close="closeBillModal"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @closed="handleClose"
  >
    <PayBox
      v-if="show && order && order.id"
      @closeBillModal="closeBillModal"
      @toggleConfirmModal="toggleConfirmModal"
      :orderId="order.id"
      :destoryDlg="destoryDlg"
      :mode="'web'"
    />
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import PayBox from "cpnts/web/PayBox/PayBox.vue";

export default {
  data() {
    return {};
  },
  components: {
    PayBox
  },
  computed: {
    ...mapState("batch", ["order"])
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    destoryDlg: {
      type: Function,
    }
  },
  methods: {
    closeBillModal() {
      this.$emit("update:show", false);
    },
    toggleConfirmModal(bool) {
      this.$emit("toggleConfirmModal", bool);
    },
    handleClose() {
      this.toggleConfirmModal(true);
    }
  }
};
</script>

<style lang="scss" scoped>
.payBillModal {
  ::v-deep .el-dialog__body {
    padding: 0;
  }
}
</style>
